import clsx from 'clsx'
import {FC, PropsWithChildren} from 'react'
import {HeaderProps} from 'react-table'

import {Contract} from "../../../../shared/models/contract";

type Props = {
    className?: string
    title?: string
    tableProps: PropsWithChildren<HeaderProps<Contract>>
}
const ContractCustomHeader: FC<Props> = ({className, title, tableProps}) => {
    return (
        <th
            {...tableProps.column.getHeaderProps()}
            className={clsx(
                className,

            )}
           /* style={{cursor: 'pointer'}}*/

        >
            {title}
        </th>
    )
}

export {ContractCustomHeader}
